import { RETAIL_TYPES } from "@/constants/retailTypes";
import { RetailType } from "@/custom-types/Dispensary";

export const getRetailerInfo = (country: string, retailType?: RetailType) => {
  if (!retailType || !RETAIL_TYPES[retailType]) {
    return "";
  }
  return RETAIL_TYPES[retailType][country] || RETAIL_TYPES[retailType]["US"];
};
